/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createRelationalNode } from '../../factoriesAny.js';
export var RelationalNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createRelationalNode: createRelationalNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRelationalNode.generated.js
// module id = 646
// module chunks = 0